import { render, staticRenderFns } from "./OfficeListTemplate.vue?vue&type=template&id=4976bd39"
import script from "./OfficeListTemplate.vue?vue&type=script&lang=ts"
export * from "./OfficeListTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4976bd39')) {
      api.createRecord('4976bd39', component.options)
    } else {
      api.reload('4976bd39', component.options)
    }
    module.hot.accept("./OfficeListTemplate.vue?vue&type=template&id=4976bd39", function () {
      api.rerender('4976bd39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/OfficeListTemplate/OfficeListTemplate.vue"
export default component.exports